import "../cca.scss";

const CcaTheme = () => <></>;
export default CcaTheme;
